import i18n from 'i18next';

import action_log_fr from './translations/action_log_fr.json';
import admin_fr from './translations/admin_fr.json';
import app_fr from './translations/app_fr.json';
import bill_fr from './translations/bill_fr.json';
import booking_fr from './translations/booking_fr.json';
import command_palette_fr from './translations/command_palette_fr.json';
import common_fr from './translations/common_fr.json';
import company_fr from './translations/company_fr.json';
import document_fr from './translations/document_fr.json';
import driver_fr from './translations/driver_fr.json';
import error_fr from './translations/error_fr.json';
import home_fr from './translations/home_fr.json';
import login_fr from './translations/login_fr.json';
import marketing_fr from './translations/marketing_fr.json';
import menu_fr from './translations/menu_fr.json';
import partner_bill_fr from './translations/partner_bill_fr.json';
import partner_fr from './translations/partner_fr.json';
import prebook_fr from './translations/prebook_fr.json';
import pricing_fr from './translations/pricing_fr.json';
import profil_fr from './translations/profil_fr.json';
import rank_fr from './translations/rank_fr.json';
import driver_communication_fr from './translations/driver_communication_fr.json';
import ride_import_fr from './translations/ride_import_fr.json';
import reservation_fr from './translations/reservation_fr.json';
import reserver_fr from './translations/reserver_fr.json';
import rider_fr from './translations/rider_fr.json';
import sent_messages_fr from './translations/sent_messages_fr.json';
import snappay_fr from './translations/snappay_fr.json';
import support_fr from './translations/support_fr.json';
import table_fr from './translations/table_fr.json';
import ticketing_fr from './translations/ticketing_fr.json';
import vehicle_fr from './translations/vehicle_fr.json';
import viadialog_fr from './translations/viadialog_fr.json';
import towers_fr from './translations/towers_fr.json';

i18n.init({
    interpolation: {
        escapeValue: false,
    },
    lng: 'fr',
    resources: {
        fr: {
            action_log: action_log_fr,
            admin: admin_fr,
            app: app_fr,
            bill: bill_fr,
            booking: booking_fr,
            command_palette: command_palette_fr,
            common: common_fr,
            company: company_fr,
            document: document_fr,
            driver_communication: driver_communication_fr,
            driver: driver_fr,
            error: error_fr,
            home: home_fr,
            login: login_fr,
            marketing: marketing_fr,
            menu: menu_fr,
            partner_bill: partner_bill_fr,
            partner: partner_fr,
            prebook: prebook_fr,
            pricing: pricing_fr,
            profil: profil_fr,
            rank: rank_fr,
            ride_import: ride_import_fr,
            reservation: reservation_fr,
            reserver: reserver_fr,
            rider: rider_fr,
            sent_messages: sent_messages_fr,
            snappay: snappay_fr,
            support: support_fr,
            table: table_fr,
            ticketing: ticketing_fr,
            vehicle: vehicle_fr,
            viadialog: viadialog_fr,
            towers: towers_fr,
        },
    },
    fallbackLng: 'fr',
});

export default i18n;
